module.exports = __webpack_public_path__ + "Roboto-LightItalic.c7b4e746cf8ecbf412fc.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.woff
// module id = 115
// module chunks = 17